import { useMemo } from 'react';
import { useExternalTeamMemberCustomFieldsAsFilterableFields } from './custom-fields';
import { useExternalTeamMemberNativeFieldsAsFilterableFields } from './default-fields';

export const useExternalTeamMemberFieldsAsFilterableField = () => {
  const {
    fields: externalTeamMemberFields,
    loading: externalTeamMemberFieldsLoading,
  } = useExternalTeamMemberCustomFieldsAsFilterableFields();
  const {
    fields: externalTeamMemberNativeFields,
    loading: externalTeamMemberNativeFieldsLoading,
  } = useExternalTeamMemberNativeFieldsAsFilterableFields();

  return useMemo(
    () => ({
      fields: [...externalTeamMemberFields, ...externalTeamMemberNativeFields],
      loading:
        externalTeamMemberFieldsLoading ||
        externalTeamMemberNativeFieldsLoading,
    }),
    [
      externalTeamMemberFields,
      externalTeamMemberFieldsLoading,
      externalTeamMemberNativeFields,
      externalTeamMemberNativeFieldsLoading,
    ],
  );
};
